import React from 'react';
import styles from './IconButton.module.css';

type IconButtonVariant = 'bordered' | 'ghost';

interface IconButtonProps {
  variant?: IconButtonVariant;
  label: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
  className?: string;
}

export default function IconButton({
  variant = 'ghost',
  label,
  disabled,
  onClick,
  children,
  className,
}: IconButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      disabled={disabled}
      className={[styles.base, styles[variant], className].filter(Boolean).join(' ')}
    >
      {children}
    </button>
  );
}
